import React from 'react';
import PropTypes from 'prop-types';
import css from './ReviewSummary.module.css';
import IconCollection from '../IconCollection/IconCollection';

function renderStars(rating) {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;
    const stars = [];
    for (let i = 0; i < 5; i++) {
        if (i < fullStars) stars.push(<span key={i} className={css.star}>★</span>);
        else if (i === fullStars && halfStar) stars.push(<span key={i} className={css.star}>☆</span>);
        else stars.push(<span key={i} className={css.starEmpty}>★</span>);
    }
    return stars;
}

const ReviewSummary = ({ reviewSummary }) => {
    const { content, rating } = reviewSummary || {};
    if (!content || typeof rating !== 'number') return null;

    return (
        <div className={css.panel}>
            <h4 className={css.heading}>Review Summary</h4>
            <div className={css.summaryBox}>
                <div className={css.left}>
                    <div className={css.rating}>{rating.toFixed(1)}</div>
                    <div className={css.stars}>{renderStars(rating)}</div>
                    <div className={css.baseText}>Base on public reviews</div>
                </div>
                <div className={css.right}>{content}</div>
            </div>
            <div className={css.note}>
                <span className={css.noteIcon}><IconCollection name="note"/></span>
                Rating pulled from trusted public sources and automatically summarized from reviews.
            </div>
        </div>
    );
};

ReviewSummary.propTypes = {
    reviewSummary: PropTypes.shape({
        content: PropTypes.string,
        rating: PropTypes.number,
    }),
};

export default ReviewSummary; 